import React from "react";
import { Button, Modal } from "antd";
import warningLogo from "../../assets/images/popup_logos/warning_logo.svg";
import "./styles.css";

const PrescriptionWarningModal = ({
  isOpen,
  onClose,
  onContinueWithoutPrescription
}) => {
  return (
    <Modal 
      open={isOpen} 
      footer={null} 
      closable={false}
      className="prescription-warning-modal"
      style={{ top: 60 }}
    >
      <div className="warning-modal-container">
        {/* Close button */}
        <button 
          className="warning-close-btn" 
          onClick={onClose}
        >
          ×
        </button>
        
        {/* Warning Icon */}
        <div className="warning-icon-container">
          <img 
            src={warningLogo} 
            alt="Warning" 
            className="warning-icon-img"
          />
        </div>
        
        {/* Title */}
        <h3 className="warning-title">
          Warning...
        </h3>
        
        {/* Message */}
        <p className="warning-message">
          Are you sure you want to update recommendation later?
        </p>
        
        {/* Buttons */}
        <div className="warning-buttons-container">
          <Button 
            className="warning-btn-outline" 
            onClick={onClose}
          >
            Add Now
          </Button>
          <Button 
            className="warning-btn-primary" 
            onClick={onContinueWithoutPrescription}
          >
            I'll update later
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PrescriptionWarningModal;